import DelayedCloseButton from "../../components/DelayedCloseButton/DelayedCloseButton"
import FeatureTermsList from "../../components/FeatureTermsList/FeatureTermsList"
import PaywallListFooter from "../../components/PaywallListFooter/PaywallListFooter"
import native from "../../native/native"
import styles from "./TogglablePlanPaywall.module.scss"

interface Props {
  Header: React.ComponentType
  isPushedOut: boolean
}

const TogglablePlanPaywall = (props: Props) => {
  return (
    <div
      className={`${styles.container} ${
        props.isPushedOut ? styles.pushOut : ""
      }`}
    >
      <HeaderContainer>{<props.Header />}</HeaderContainer>
      <div className={styles.scrollableList}>
        <FeatureTermsList />
      </div>
      <PaywallListFooter />
    </div>
  )
}

const HeaderContainer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <div className={styles.headerContainer}>
      {children}
      <DelayedCloseButton
        className={styles.closeButton}
        onClick={() => native.postNativeEvent("close")}
      />
    </div>
  )
}

export default TogglablePlanPaywall
